module.exports = __webpack_public_path__ + "media/logo_parallax.7238459d.mp4";